<template>
  <div class="taskcenterdetail">
    <div class="page-title">任务详情</div>
    <div class="task-flow-wrap">
      <img class="task-flow" src="@/assets/task_flow_pc.png"/>
    </div>
    <div class="identification-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">需求包下载</div>
        </div>
      </div>
      <div class="identification-inner-content">
        <div class="identification-inner" @click="handleDownloadTest">
          <div class="inner-icon"></div>
          <div class="inner-desc">下载需求包</div>
          <div class="icon-download"></div>
        </div>
      </div>
      <el-form
        class="basics-form"
        ref="basicsForm"
        :model="formData"
        label-position="left"
        label-width="100px"
      >
        <div class="form-item form-item-base">
          <el-form-item label="小模式名称:">
            <el-input
              :disabled="true"
              readonly
              class="custom-input txt-normalstyle width300"
              :value="
                formData && formData.mid_table_remark_001
                  ? formData.mid_table_remark_001
                  : ''
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="项目状态:" class="form-item-usertype">
            <el-input
              :disabled="true"
              readonly
              class="custom-input txt-normalstyle width300"
              :value="
                formData && formData.mid_table_remark_013
                  ? (formData.mid_table_remark_013 == 1301 ? '发包中' : (formData.mid_table_remark_013 == 1302 ? '已接包' : '已完成'))
                  : ''
              "
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item form-item-base">
          <el-form-item label="截止时间:">
            <el-input
              :disabled="true"
              readonly
              class="custom-input txt-normalstyle width300"
              :value="getDays(formData)"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目发布方:" class="form-item-usertype">
            <el-input
              :disabled="true"
              readonly
              class="custom-input txt-normalstyle width300"
              :value="
                formData && formData.mid_table_remark_014
                  ? formData.mid_table_remark_014
                  : ''
              "
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item form-item-base">
          <el-form-item label="H5页面数:">
            <el-input
              :disabled="true"
              readonly
              class="custom-input txt-normalstyle width300"
              :value="
                formData && formData.mid_table_remark_016
                  ? formData.mid_table_remark_016
                  : ''
              "
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item form-item-base">
          <el-form-item label="页面数明细：">
            <el-input
              class="custom-input project-desc custom-txt"
              v-model="formData.mid_table_remark_017"
              type="textarea"
              maxlength="100"
              show-word-limit
              placeholder="请填写"
              :readonly="true"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="bottom-buttons">
          <template v-if="userInfo.user_remark_018==1802||userInfo.user_remark_018==1803||userInfo.user_remark_018==1804">
            <el-button
              v-if="userInfo.user_remark_024==2402"
              class="custom-button btn-ff3333"
              >您已经开发过小模式，请报价征集需求</el-button
            >
            <el-button
              v-else
              class="custom-button btn-ff3333"
              @click="handleQuotedPrice"
              >立即报价</el-button
            >
          </template>
          <el-button
            v-else
            class="custom-button btn-ff3333"
            >您还不是认证开发者，请先认证</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="tools-box" v-if="userInfo.user_remark_018==1802||userInfo.user_remark_018==1803||userInfo.user_remark_018==1804">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">中标者</div>
        </div>
      </div>
        <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">序号</div>
        <div class="cell-column projecttype-cell">报价人</div>
        <div class="cell-column project-yusuan-cell">报价金额</div>
        <div class="cell-column task-publishtime-cell">报价时间</div>
        <div class="cell-column operate-cell">状态</div>
      </div>
      <div class="table-list-box">
        <template v-if="getList.length">
          <div v-for="(item, idx) in getList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ idx + 1 }}
            </div>
            <div class="cell-column projecttype-cell">
              {{ item.mid_table_remark_001 }}
            </div>
            <div class="cell-column project-yusuan-cell">
              {{ item.mid_table_remark_006 }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert}}
            </div>
            <div 
              class="cell-column operate-cell"
              :class='item.mid_table_remark_007 == 7001 ? "colerblue" : (item.mid_table_remark_007 == 7002 ? "colerred" : "colergray") '
            >
              {{ item.mid_table_remark_007 == 7001 ? "竞标中" : (item.mid_table_remark_007 == 7002 ? "已中标" : "已失效") }}
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </div>
    <div class="tools-box" v-if="userInfo.user_remark_018==1802||userInfo.user_remark_018==1803||userInfo.user_remark_018==1804">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">报价列表</div>
        </div>
      </div>
        <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">序号</div>
        <div class="cell-column projecttype-cell">报价人</div>
        <div class="cell-column project-yusuan-cell">报价金额</div>
        <div class="cell-column task-publishtime-cell">报价时间</div>
        <div class="cell-column operate-cell">状态</div>
      </div>
      <div class="table-list-box">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ idx + 1 }}
            </div>
            <div class="cell-column projecttype-cell">
              {{ item.mid_table_remark_001 }}
            </div>
            <div class="cell-column project-yusuan-cell">
              {{ item.mid_table_remark_006 }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert}}
            </div>
            <div 
              class="cell-column operate-cell"
              :class='item.mid_table_remark_007 == 7001 ? "colerblue" : (item.mid_table_remark_007 == 7002 ? "colerred" : "colergray") '
            >
              {{ item.mid_table_remark_007 == 7001 ? "竞标中" : (item.mid_table_remark_007 == 7002 ? "已中标" : "已失效") }}
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </div>
    <QuotedPrice ref="dialogQuotedPrice" :taskInfo="formData" :userInfo="userInfo"></QuotedPrice>
  </div>
</template>
<script>
import QuotedPrice from "@/components/dialog/QuotedPrice";
import NoneData from "@/components/NoneData";
import pageCommon from "@/utils/pagecommon";
import taskApi from "@/api/task";
export default {
  name: "TaskCenterDetail",
  components: {NoneData, QuotedPrice },
  created() {
    let _this = this;
    _this.currentPage = 1;
    _this.total = 1;
    _this.taskList = [];
    _this.isRequesting = true;
    _this.getOfferList();
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 10);    
    _this.getTaskInfo();
    _this.getTaskList();
  },
  data() {
    return {
      showPassword: false,
      taskList: [],
      getList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      isRequesting: false,
      formData:{}
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  methods: {
    getDays: function (val) {
      let startDate='';
      let endDate='';
      if(val.time_4_end){
          endDate =  new Date(val.time_4_end.replace(/-/g, "/")).getTime();
      }else if(val.time_insert){
          startDate = new Date(val.time_insert.replace(/-/g, "/"));
          endDate = startDate.setDate(startDate.getDate() + 30);
      }else{
          return '--';
      }
      let currentDate = new Date().getTime();
      let days = (endDate-currentDate) / 1000 / 60 / 60 / 24;
      let daysAfter = days>0?days.toFixed(0):0
      return daysAfter + '天后截止';
    },
    handleQuotedPrice: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_007:'7001,7002',
        mid_table_remark_013:'1301,1302,1304',
        is_online:0
      };
      let requestOfferData = {
        isloading: true,
        mid_table_remark_004: _this.$route.query.id
      };
      let requestData = {
        isloading: true,
        id_public_middle_table: _this.$route.query.id
      };
      if(!_this.sending){
        _this.sending=true;
        pageCommon.apiRequestCommon(taskApi, "getAllTaskData", requestData).then(
          (res) => {
            if(res.result_num>0){
              if(res.page_content[0].mid_table_remark_013==1301){
                pageCommon.apiRequestCommon(taskApi, "getOfferData", requestTaskData).then(
                  (res) => {
                    if(res.result_num>0){
                      _this.$message.error("您有正在竞标或正在进行的中标的任务！");
                    }else{
                      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestOfferData).then(
                        (res) => {
                          if(res.result_num>50){
                            _this.$message.error("报价人数已满！");
                          }else{
                            _this.sending = false;
                            _this.$refs["dialogQuotedPrice"].showDialog = true;
                          }
                        },
                        (err) => {
                          _this.sending = false;
                          if (err.sysUserLoginError) {
                            _this.$message.error("系统异常，请稍后刷新重试！");
                          } else {
                          }
                        }
                      );
                    }
                  },
                  (err) => {
                    _this.sending = false;
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              } else {
                _this.sending = false;
                _this.$message.error("此项目报价已结束，看看其他项目吧！");
              }
            }else{
              _this.sending = false;
              _this.$message.error("此项目或已被删除");
            }
          },
          (err) => {
            _this.sending = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }
    },
    getTaskInfo: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 10,
        id_public_middle_table: _this.$route.query.id,
        isloading: true,
      };
      pageCommon.apiRequestCommon(taskApi, "getTaskData", requestData).then(
        (res) => {
          this.formData=res.page_content[0];
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    getTaskList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        mid_table_remark_004: _this.$route.query.id,
        mid_table_remark_007:7002
      };
      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestTaskData).then(
        (res) => {
          console.log(res)
          this.getList=res.page_content;
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    getOfferList: function () {
      let _this = this;
      let requestData = {
        isloading: true,
        mid_table_remark_004: _this.$route.query.id
      };
      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestData).then(
        (res) => {
          let taskList = res.page_content;
          if (taskList.length < _this.pageSize) {
          }
          // 用concat
          _this.taskList.push(...taskList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          // _this.collectList = [];
          _this.isRequesting = false;
          _this.taskList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handleDownloadTest(){
      if(this.formData.mid_table_remark_015){
        window.open(this.formData.mid_table_remark_015);
      } else {
        this.$confirm("暂无可下载的需求包, 请联系相关人员", "提示", {
          type: "warning",
          showCancelButton: false,
        }).then(() => {});
      }
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.taskcenterdetail {
  position: relative;
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  /deep/.left-red-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
  }
  .task-flow-wrap{
    margin-top:50px;
    width:990px;
    height:252px;
    .task-flow{
      display:block;
      width:100%;
      height:100%;
    }
  }
  .identification-box,
  .tools-box{
    position: relative;
    width: 100%;
    margin-top: 88px;
    .identification-inner,
    .tools-inner {
      position: relative;
      width: 100%;
      height: 200px;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      box-sizing: border-box;
      margin-top: 32px;
      display: flex;
      display: -webkit-flex;
    }
  }
  .identification-inner-content {
    display: flex;
    align-content: center;
    justify-content: space-between;
    .identification-inner {
      width: 49%;
    }
  }
  .identification-box {
    margin-right:50px;
    .identification-inner {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_down.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        border-color: #ec4040;
        background-color: #fff8f8;
        .inner-icon {
          background: url(~@/assets/icon_down_hover.png) no-repeat right
            top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          background: url(~@/assets/icon_download_current.png) no-repeat right
            top;
        }
      }
    }
  }
  .width100per {
    width: 100%;
  }
}
.basics-form{
    position: relative;
    margin-top: 40px;

    .form-item {
      width: 990px;
      display: flex;
      align-items: center;

      &.form-item-base {
        margin-bottom: 30px;
        .form-item-usertype {
          margin-left: 45px;
        }
      }

      &.form-item-normal {
        padding-top: 30px;
        padding-bottom: 8px;
        box-sizing: border-box;
        border-top: 1px solid rgb(238, 238, 238);

        .buttons {
          display: flex;
          align-items: center;
          // margin-left: 10px;
          .custom-button {
            margin-left: 10px;

            &:first-child {
              margin-left: 30px;
            }
          }
        }
      }

      /deep/ .el-form-item__label {
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(153, 153, 153, 1);
      }

      .txt-normalstyle {
        height: 46px;
        line-height: 46px;

        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(102, 102, 102, 1);
      }

      .width300 {
        width: 300px;
      }

      // .btn-modify {
      //   width: 80px;
      //   height: 46px;
      //   line-height: 46px;
      //   font-size: 16px;
      //   margin-bottom: 22px;
      // }
    }

    .line {
      width: 100%;
      height: 1px;
      border-bottom: 1px solid rgb(238, 238, 238);
      margin: 30px 0;
      box-sizing: border-box;
    }
    .bottom-buttons {
      display: flex;
      .custom-button {
        width:320px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
      }
    }
  }
.cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .tasktype-cell {
    position: relative;
    width:20%;
  }
  .projecttype-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .project-yusuan-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .task-publishtime-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .operate-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .table-header-box {
    position: relative;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.colerblue{
        color:#0d84e0;
      }
      &.colerred{
        color:#ec4040;
      }
      &.colergray{
        color:#878787;
      }
    }
    .projecttype-cell,
    .project-yusuan-cell,
    .demand-status-cell,
    .demand-publishtime-cell {
      text-align: center;
    }
    .white-cell {
      text-align: center;
    }
  }
  /deep/ .custom-input {
      &.project-desc {
        width: 750px;
        .el-textarea__inner {
          border: 1px solid #eaeaea;
          background-color: #F5F7FA;
          position: relative;
          width: 750px;
          height: 100px;
          padding: 17px 13px;
          resize: none;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 24px;
          &:focus {
            border-color: #07060b;
          }
          &::placeholder {
            color: #c2c2c2;
          }
          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #c2c2c2;
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #c2c2c2;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            color: #c2c2c2;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            color: #c2c2c2;
          }
        }
      }
    }
</style>